export interface DateTimeValue {
  timeZone: string;
  date: string;
  time: string;
}

interface DateTimeViewerProps {
  value: DateTimeValue;
}

export function DateTimeViewer({ value }: DateTimeViewerProps) {
  return (
    <div className='flex flex-row items-center gap-2'>
      {/* <ClockIcon className='size-3.5  text-neutral-600' /> */}
      <span className='text-neutral-950 text-sm text-nowrap'>
        {String(value.time)} on {String(value.date)}
      </span>
    </div>
  );
}
